import React from 'react';
import { Button } from './ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({
  page,
  pages,
  total,
  pageSize,
  hasNext,
  hasPrev,
  onPageChange,
  onPageSizeChange,
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-4">
      {/* Navigation Controls */}
      <div className="flex items-center gap-2 w-full sm:w-auto justify-center sm:justify-start">
        <Button 
          variant="outline" 
          size="sm"
          disabled={!hasPrev} 
          onClick={() => onPageChange(Math.max(1, page - 1))}
          className="h-9 px-3 sm:px-4"
        >
          <ChevronLeft className="w-4 h-4 sm:mr-1" />
          <span className="hidden sm:inline">Prev</span>
        </Button>
        <span className="text-xs sm:text-sm text-gray-600 whitespace-nowrap">
          <span className="hidden sm:inline">Page </span>
          <span className="font-medium">{Math.max(1, page)}</span>
          <span className="hidden sm:inline"> of {Math.max(1, pages)}</span>
          <span className="sm:hidden">/{Math.max(1, pages)}</span>
          <span className="hidden md:inline"> (Total {total})</span>
        </span>
        <Button 
          variant="outline" 
          size="sm"
          disabled={!hasNext} 
          onClick={() => onPageChange(page + 1)}
          className="h-9 px-3 sm:px-4"
        >
          <span className="hidden sm:inline">Next</span>
          <ChevronRight className="w-4 h-4 sm:ml-1" />
        </Button>
      </div>
      
      {/* Page Size Selector */}
      <div className="flex items-center gap-2 w-full sm:w-auto justify-center sm:justify-end">
        <span className="text-xs sm:text-sm text-gray-600 whitespace-nowrap">
          <span className="hidden sm:inline">Page size</span>
          <span className="sm:hidden">Size</span>
        </span>
        <Select value={String(pageSize)} onValueChange={(v)=> onPageSizeChange(Number(v))}>
          <SelectTrigger className="w-20 sm:w-24 h-9 focus-gold text-xs sm:text-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="10">10</SelectItem>
            <SelectItem value="20">20</SelectItem>
            <SelectItem value="50">50</SelectItem>
            <SelectItem value="100">100</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default Pagination;

